module.exports = __webpack_public_path__ + "src/img/materialIcon.00babb5b.svg";